
<ul class="navbar-nav mx-2">
  <li class="nav-item">
    <a href="javascript:;" class="nav-link">
      <i class="d-inline-block {{ currentLanguage.icon }}"></i>
    </a>
    <ul class="dropdown-menu">
      @for (language of languages; track language.name) {
        @if(language.name != currentLanguage.name) {
          <li class="nav-item" *ngIf="language.name != currentLanguage.name">
            <a
              class="dropdown-item"
              href="javascript:;"
              (click)="changeLanguage(language.name)"
            >
              <i class="d-inline-block {{ language.icon }} mr-1"></i>
              {{ language.displayName }}
            </a>
          </li>
        }
      }
    </ul>
  </li>
</ul>

